import type { SyntheticEvent } from 'react';

/**
 * 🔒 A closed box's tooltip names the whole text only where the box cuts it (piece 3, row T3362), so a screen reader
 * is not given the name a second time where nothing is cut. Read from the drawn box on hover, focus and edit.
 */
export function nameWhenCut(event: SyntheticEvent<HTMLInputElement>): void {
  nameInputWhenCut(event.currentTarget);
}

/** The same read for an input held by ref, run again when its value changes under a resting pointer (T3472). */
export function nameInputWhenCut(input: HTMLInputElement): void {
  if (input.value !== '' && input.scrollWidth > input.clientWidth) input.title = input.value;
  else input.removeAttribute('title');
}
